import { IOnInit } from "angular";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../ui/authorizedUiElement";
import { vsServiceName as userDetailTabsServiceName } from "./service";
import { UserInfo, UserProfile } from "../../../application/UserProfile";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

export class UserDetailController implements IOnInit {
  static $inject = [userDetailTabsServiceName, ServerUtilityName];

  /*bindings*/
  user!: UserProfile;
  /*end bindings*/

  constructor(
    private readonly userDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>,
    private readonly serverUtility: ServerUtility
  ) {}

  $onInit(): void {}

  public isUserLocked(): boolean {
    return !!this.user.LockedDate;
  }

  lockButtonClicked() {
    const currentlyLocked = this.isUserLocked();
    this.serverUtility
      .post<UserProfile>({
        url: `/api/user/${this.user.Id}/lock`,
        postObject: { Lock: !currentlyLocked },
      })
      .then((profile) => {
        this.user.LockedDate = profile.LockedDate;
      });
  }
}
